import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { STEPS_MAP } from '../constants';
import AmountAchOut from './AmountAchOut';
import ReviewAchOut from './ReviewAchOut';
import TransferDoneAchOut from './TransferDoneAchOut';
import ErrorEnrollAchOut from './ErrorEnrollAchOut';
import { VIEWS_MAP } from '../../../router/constants';
import { MFA } from '../../../generic-components/MFA';
import { AchOutContext } from '../pages';
import { IServerErrorResponse } from '../../../types';
import { handleOnAchOutError } from '../services/onAchOutErrorService';
import { BankTransferIntro } from '../pages/BankTransferIntro/BankTransferIntro';
import FullPageLoader from '../../../components/FullPageLoader';
import { useStore } from '../../../store';

interface IProps {
  activeStep: number;
  enrollErrorData: {errCode: number, errMsg: string};
  handleStepSubmit: (data?: any) => void;
  handleEditMode: (type: string) => void;
}

const AchOutStepSwitch = ({
  activeStep, enrollErrorData, handleStepSubmit, handleEditMode,
}: IProps) => {
  const navigate = useNavigate();
  const FlowContext = useContext(AchOutContext);
  const supplierId = useStore(state => state.supplierId);
  const transferAmount = useStore(state => state.transferAmount);

  const getActiveStep = () => {
    switch (activeStep) {
      case STEPS_MAP.ZERO_STATE:
        return (<FullPageLoader />);
      case STEPS_MAP.ENROLLMENT:
        return <BankTransferIntro onSubmit={handleStepSubmit} />;
      case STEPS_MAP.TRANSFER_AMOUNT:
        return <AmountAchOut onSubmit={handleStepSubmit} />;
      case STEPS_MAP.REVIEW_CONFIRM:
        return <ReviewAchOut setEditMode={handleEditMode} onSubmit={handleStepSubmit} />;
      case STEPS_MAP.MFA:
        return (
          <MFA
            mfaActionData={FlowContext?.achOutResponse}
            onSuccess={(data: any) => {
              FlowContext.setAchOutResponse(data);
            }}
            onExternalFlowError={(errData: IServerErrorResponse) => {
              if (FlowContext?.setActiveStep) FlowContext.setActiveStep(STEPS_MAP.REVIEW_CONFIRM);
              handleOnAchOutError(errData, navigate, supplierId, transferAmount);
            }}
            handleBackClick={() => FlowContext.setActiveStep(STEPS_MAP.REVIEW_CONFIRM)}
            useNewDesign
          />
        );
      case STEPS_MAP.TRANSFER_DONE:
        return <TransferDoneAchOut makeAnotherTransfer={handleStepSubmit} />;
      case STEPS_MAP.ENROLL_ERROR:
        return <ErrorEnrollAchOut enrollErrorData={enrollErrorData} />;
      default:
        navigate(`/${VIEWS_MAP.DASHBOARD}`);
        return <div className='hidden' />;
    }
  };

  return getActiveStep();
};

export default AchOutStepSwitch;
